<div class="allowed-domains">
  <div class="allowed-domains-add" *ngIf="(isLoading$ | async) === false">
    <div class="allowed-domains-add-text">
      <div class="allowed-domains-add-text-description">
        {{ 'policyPage.config.trustedDomainsContent.allowedDomainsDesc' | labelsProvider }}
      </div>
    </div>
    <div class="allowed-domains-add-button" *ngIf="editable">
      <button class="add-domain-button" (click)="addDomainClicked()">
        <span>{{ 'policyPage.config.trustedDomainsContent.addDomain' | labelsProvider }}</span>
      </button>
    </div>
  </div>
  <div class="divider" *ngIf="(isLoading$ | async) === false"></div>
  <div class="allowed-domains-table-section" *ngIf="(isLoading$ | async) === false">
    <div class="allowed-domains-table-section-title">
      {{ 'policyPage.config.trustedDomainsContent.domainsList' | labelsProvider }}
    </div>
    <app-effective-policy-settings-button
      class="policy-field-effective-policy-settings-button"
      [effectivePolicySetting]="EffectivePolicySettingEnum.domainsList"
      [platform]="integrationModel.platform"
    >
    </app-effective-policy-settings-button>

    <div class="allowed-domains-table-section-body" *ngIf="(isLoading$ | async) === false">
      <div class="allowed-domains-table-section-body-search">
        <app-autocomplete-search
          class="allowed-domains-table-section-body-search-box"
          placeholder="Search..."
          (autocompleteOnChange)="domainSearched($event)"
          [values]="domainsForSearchBox"
          [resetSearchBox$]="resetSearchBoxBehavioralSubject$"
        ></app-autocomplete-search>
        <app-audit-log-events-export (exportClick)="exportDomainsToCSV()" />
      </div>

      <p-table [scrollable]="true" [value]="(domainsCurrentPage$ | async) ?? []" class="main-table">
        <ng-template pTemplate="header">
          <tr>
            <th>Domain ({{ (domainsCurrentPage$ | async)?.length || 0 }})</th>
            <!-- Actions Column -->
            <th class="actions-column"></th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-domain>
          <tr class="table-row">
            <td class="domain-cell">{{ domain.displayName }}</td>

            <td class="actions-cell">
              <div class="delete-column-icon" (click)="$event.stopPropagation()">
                <img
                  *ngIf="editable"
                  src="assets/images/common/delete.svg"
                  class="delete-icon"
                  (click)="removeDomainClicked(domain)"
                />
              </div>
            </td>
          </tr>
        </ng-template>
        <!-- When the table is empty ( data length 0) we get here -->
        <ng-template pTemplate="emptymessage">
          <app-no-data [tableNotFoundText]="tableNotFoundText" [tableNotFoundIcon]="tableNotFoundIcon"></app-no-data>
        </ng-template>
      </p-table>
    </div>
  </div>

  <div *ngIf="isLoading$ | async" class="allowed-domains-spinner">
    <mat-progress-spinner color="primary" mode="indeterminate"> </mat-progress-spinner>
  </div>

  <app-form-footer
    *ngIf="editable"
    [changesWereDone]="changesWereDone"
    (resetChanges)="resetForm()"
    (saveChanges)="updatePolicyConfig()"
    (cancelSettings)="cancelSettings()"
  ></app-form-footer>
</div>
